import { of } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { BaseDataSource, QueryParamsModel, QueryResultsModel, MessageType, LayoutUtilsService } from 'app/core/_base/crud';
import { ListDialogService } from '../../Services/list-dialog.service';

export class ListDialogDataSource extends BaseDataSource {
	constructor(private service: ListDialogService,
		private layoutUtilsService: LayoutUtilsService) {
		super();
	}

	loadList_Emp(queryParams: QueryParamsModel) {
		this.service.lastFilter$.next(queryParams);
		this.loadingSubject.next(true);
		this.service.findData_Emp(queryParams)
			.pipe(
				tap(resultFromServer => {
					if (resultFromServer && resultFromServer.status == 1) {
						this.entitySubject.next(resultFromServer.data);
						var totalCount = resultFromServer.page.TotalCount || (resultFromServer.page.AllPage * resultFromServer.page.Size);
						this.paginatorTotalSubject.next(totalCount);
					} else {
						this.entitySubject.next([]);
						this.paginatorTotalSubject.next(0);
						this.layoutUtilsService.showErorr(resultFromServer.error.message);
					}
				}),
				catchError(err => of(new QueryResultsModel([], err))),
				finalize(() => this.loadingSubject.next(false))
			).subscribe();
	}

	loadList_Product(queryParams: QueryParamsModel) {
		this.service.lastFilter$.next(queryParams);
		this.loadingSubject.next(true);

		this.service.findData_Product(queryParams)
			.pipe(
				tap(resultFromServer => {
					if (resultFromServer && resultFromServer.status == 1) {
						this.entitySubject.next(resultFromServer.data);
						var totalCount = resultFromServer.page.TotalCount || (resultFromServer.page.AllPage * resultFromServer.page.Size);
						this.paginatorTotalSubject.next(totalCount);
					} else {
						this.entitySubject.next([]);
						this.paginatorTotalSubject.next(0);
						this.layoutUtilsService.showErorr(resultFromServer.error.message);
					}
				}),
				catchError(err => of(new QueryResultsModel([], err))),
				finalize(() => this.loadingSubject.next(false))
			).subscribe();
	}
	loadList_AllProduct(queryParams: QueryParamsModel) {
		this.service.lastFilter$.next(queryParams);
		this.loadingSubject.next(true);

		this.service.findData_ProductWFilter(queryParams)
			.pipe(
				tap(resultFromServer => {
					if (resultFromServer && resultFromServer.status == 1) {
						this.entitySubject.next(resultFromServer.data);
						var totalCount = resultFromServer.page.TotalCount || (resultFromServer.page.AllPage * resultFromServer.page.Size);
						this.paginatorTotalSubject.next(totalCount);
					} else {
						this.entitySubject.next([]);
						this.paginatorTotalSubject.next(0);
						this.layoutUtilsService.showErorr(resultFromServer.error.message);
					}
				}),
				catchError(err => of(new QueryResultsModel([], err))),
				finalize(() => this.loadingSubject.next(false))
			).subscribe();
	}
}
